export default __webpack_public_path__ + "static/media/errorIcon.a4f047fc.png";